import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import {
  setClientValue,
  setHomeValue,
  setInnerPagesList,
  setStepInnerPage,
} from "../../../actions";
import { options, client } from "../../../operations";
import { Body, Text } from '../../Common/Form';
import { Select, Input, Button, AsyncSelect } from '../../ui';
import Continue from "../../Common/Continue";
import SendEmail from "../../Common/SendEmail";
import { mapSelectList } from "../../../helpers";
import { getStreetsAsync } from '../../../operations/options';

import aptoIcon from '../../../assets/icons/icon-apto.svg';
import homeIcon from '../../../assets/icons/icon-house.svg';

class HogarForm_5 extends Component {

  constructor(props) {
    super(props);
    this.state = { continue: false };
    this.continueCondition = this.continueCondition.bind(this);
    this.applyCondition = this.applyCondition.bind(this);
    this.getFirstColumnContent = this.getFirstColumnContent.bind(this);
    this.getSecondColumnContent = this.getSecondColumnContent.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { stepInnerPage, setInnerPagesList } = this.props;
    if(!stepInnerPage || stepInnerPage.name !== 'sendEmail')
      setInnerPagesList([
        { name: 'homeForm5', back: '' },
        { name: 'sendEmail', back: '', backButton: false }
      ]);
  }

  componentDidMount() {
    const { getDepartments, getMontevideoNeighborhoods } = this.props;
    this.checkContinueState(null);
    getDepartments();
    getMontevideoNeighborhoods();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  applyCondition() {
    
    const {
      addressState, addressCity,
      mvdNeighborhoods,
      houseType, aptoFloors,
      propertyContainsGrille,
      propertyContainsAlarm
    } = this.props;

    const isMDV = addressState && addressState.value === "1";
    const neighborhood = addressCity ? mvdNeighborhoods.find(x => parseInt(x.Code, 0) === parseInt(addressCity.value, 0)) : null;
    const canEmit = neighborhood ? neighborhood.CanEmit : true;
    const cityOk = !isMDV || (isMDV && canEmit);

    const typeOk = (houseType === 'A' && aptoFloors > 1) // Es apto y esta en un segundo piso o mayor
                      || // o
                    (
                      (houseType === 'H' || (houseType === 'A' && aptoFloors === 1)) // Es casa o apto en primero piso
                        && // y
                      (propertyContainsGrille || propertyContainsAlarm) // tiene alarma, reja o ambas.
                    );

    return cityOk && typeOk;
  }

  continueCondition() {

    const {
      addressState, addressCity, 
      addressStreet, addressNumber
    } = this.props;

    return (
      addressState != null &&
      addressCity != null &&
      addressStreet != null &&
      addressNumber != ''
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition() && this.applyCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getFirstColumnContent() {

    const {
      showError, departments,
      onHomeValueChange, streets,
      addressState, onDepartmentChange,
      addressCity, onCityChange,
      cities, addressStreet,
      getStreets, addressNumber,
      onStreetChange, houseType,
      mvdNeighborhoods,
    } = this.props;

    const isMDV = addressState && addressState.value === "1";

    return (
      <>
        <div className="Hogar-formRow Hogar-formRow-2">
          <div style={{ flex: 1 }}>
            <Select
              id="depto"
              leftIcon={houseType === 'A' ? aptoIcon : homeIcon}
              name="depto"
              value={addressState}
              showAlert={showError && !addressState}
              onChange={onDepartmentChange}
              placeholder="Seleccione un departamento"
              options={mapSelectList(departments)}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              id="city"
              leftIcon={houseType === 'A' ? aptoIcon : homeIcon}
              name="city"
              value={addressCity}
              showAlert={showError && !addressCity}
              onChange={(value) => { onCityChange(value, isMDV) }}
              placeholder={ isMDV ? "Seleccione un barrio" : "Seleccione una ciudad" }
              options={ isMDV ? mapSelectList(mvdNeighborhoods, 'Code', 'Name') : mapSelectList(cities) }
              noOptionsMessage={() => "Sin ciudades. Seleccione el Departamento primero."}
              loadingMessage={() => "Cargando.."}
            />
          </div>
        </div>
        <div className="Hogar-formRow Hogar-formRow-2">
          <div style={{ flex: 1, paddingBottom: '4px' }}>
            <AsyncSelect
              id="address"
              leftIcon={houseType === 'A' ? aptoIcon : homeIcon}
              name="calle"
              value={addressStreet}
              onChange={onStreetChange}
              placeholder="Seleccione una calle"
              loadOptions={(inputValue) => getStreetsAsync(addressState, addressCity, inputValue)}
              // cacheOptions
              showAlert={showError && !addressStreet}
              disabled={addressCity === null}
              noOptionsMessage={() =>
                'Sin calles. Seleccione el Departamento y la Ciudad primero, y comience a escribir el nombre'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Input
              id="addressNumber"
              name="addressNumber"
              placeholder="Nro. de puerta, manzana, solar"
              maxLength="50"
              type="text"
              value={addressNumber}
              onChange={(event) => { onHomeValueChange('addressNumber', event.target.value) }}
              leftIcon={houseType === 'A' ? aptoIcon : homeIcon}
              showAlert={showError && !addressNumber}
              autoComplete="nope"
            />
          </div>
        </div>
      </>
    );
  }

  checkBooleanOption(line, prop, propName, text, trueText = 'Si', falseText = 'No') {
    const { onHomeValueChange } = this.props;
    return (
      <div className={`Hogar-checks ${'Hogar-checks-' + line}`}>
        <Text className='Hogar-option-text'> {text} </Text>
        <div className={`Hogar-options-check ${'Hogar-options-check-' + line}`}>
          <div className="Hogar-option-check">
            <label htmlFor={propName + '-yes'}> <span> { trueText } </span>
              <div className={`Hogar-radioWrapper ${prop ? 'Hogar-radioWrapper--on' : ''}`}>
                <input 
                  type="radio" name={propName} id={propName + '-yes'} checked={prop}
                  onChange={() => { onHomeValueChange(propName, true) }} 
                  />
              </div>
            </label>
          </div>
          <div className="Hogar-option-check">
            <label htmlFor={propName + '-no'}> <span> { falseText } </span>
              <div className={`Hogar-radioWrapper ${!prop ? 'Hogar-radioWrapper--on' : ''}`}>
                <input 
                  type="radio" name={propName} id={propName + '-no'} checked={!prop}
                  onChange={() => { onHomeValueChange(propName, false) }} 
                />
              </div>
            </label>
          </div>
        </div>
      </div>
    );
  }

  checkNumberOption(number, text) {
    const { onHomeValueChange, propertyFloorsCount } = this.props;
    return (
      <div className="Hogar-option-check">
        <label htmlFor={"propertyFloorsCount" + number}> <span> { text } </span>
          <div className={`Hogar-radioWrapper ${number === propertyFloorsCount ? 'Hogar-radioWrapper--on' : ''}`}>
            <input 
              type="radio" name="propertyFloorsCount" id={"propertyFloorsCount" + number} checked={number === propertyFloorsCount}
              onChange={() => { onHomeValueChange("propertyFloorsCount", number) }} 
            />
          </div>
        </label>
      </div>
    );
  }

  getSecondColumnContent() {

    const {
      propertyContainsGrille,
      propertyContainsAlarm,
      propertyRoofType,
      propertyFloorsCount,
    } = this.props;

    return (
      <>
        {this.checkBooleanOption(1, propertyContainsGrille, "propertyContainsGrille", '¿La propiedad cuenta con rejas en todas las aberturas?')}
        {this.checkBooleanOption(1, propertyContainsAlarm, "propertyContainsAlarm", '¿La propiedad cuenta con un sistema de alarmas?')}
        {this.checkBooleanOption(2, propertyRoofType, "propertyRoofType", '¿Qué tipo de techo tiene la propiedad?', 'Chapa / Techos livianos', 'Planchada / Teja / Mampostería')}
        <div className="Hogar-checks Hogar-checks-3">
          <Text className='Hogar-option-text'> ¿Cuantos pisos tiene? </Text>
          <div className="Hogar-options-check Hogar-options-check-3">
            {this.checkNumberOption(1, "1")}
            {this.checkNumberOption(2, "2")}
            {this.checkNumberOption(3, "3 o más")}
          </div>
        </div>
      </>
    );
  }

  render() {

    const { continue: toContinue } = this.state;
    const { stepInnerPage, quoter, onContactClick } = this.props;

    switch (stepInnerPage.name) {
      case 'homeForm5':
        return (<div>
                  <Text style={{ paddingTop: '25px'}} className="Text-question">
                    Completá la siguiente información del inmueble
                  </Text>
                  <Body columnContent={this.getFirstColumnContent} />
                  <Body columnContent={this.getSecondColumnContent} />
                  <Text style={{ paddingTop: '25px'}} className="Text-detail"> 
                    * Esta cobertura solo admite paredes de mampostería
                  </Text>
                  { this.continueCondition() && !this.applyCondition() && 
                    <>
                      <Text style={{ padding: '15px 50px 0px'}} className="Text-detail Text-error"> 
                        Las características que indicas no aplican para nuestro seguro de Hogar Standard. Si lo deseas un ejecutivo de cuentas te contactará lo antes posible para ofrecerte la mejor cotización para lo que estás buscando.
                      </Text>
                      <div
                        style={{'display': 'inline-flex'}}
                        className="OptionInfo-options-option"
                        onClick={() => {onContactClick(quoter)}}>
                        Contactar
                      </div>
                    </>
                  }
                  <Continue state={toContinue}/>
                </div>);
      case 'sendEmail':
        return <SendEmail quoteAccepted={true} apply={false}/>;
    };
    return <div/>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,
    quoter: state.options.quoter,
    stepInnerPage: state.steps.stepInnerPage,

    addressState: state.home.addressState,
    addressCity: state.home.addressCity,
    addressStreet: state.home.addressStreet,
    addressNumber: state.home.addressNumber,

    departments: state.options.departments,
    mvdNeighborhoods: state.home.montevideoNeighborhoods,
    cities: state.options.cities,
    streets: state.options.streets,

    houseType: state.home.houseType,
    aptoFloors: state.home.aptoFloors,
    propertyContainsGrille: state.home.propertyContainsGrille,
    propertyContainsAlarm: state.home.propertyContainsAlarm,
    propertyRoofType: state.home.propertyRoofType,
    propertyFloorsCount: state.home.propertyFloorsCount,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDepartments: () => {
      dispatch(options.getDepartments('home'));
    },
    getMontevideoNeighborhoods: () => {
      dispatch(options.getMontevideoNeighborhoods());
    },
    onDepartmentChange: (addressState) => {
      dispatch(options.setDepartment(addressState, 'home'));
    },
    onCityChange: (addressCity, isMVD) => {
      dispatch(options.setCity(addressCity, 'home', isMVD));
    },
    getStreets: (val, callback) => {
      dispatch(options.getStreets(val, callback));
    },
    onStreetChange: (addressStreet) => {
      dispatch(setHomeValue('addressStreet', addressStreet));
    },

    onHomeValueChange: (type, value) => {
      dispatch(setHomeValue(type, value));
    },
    setInnerPagesList: (page) => {
      dispatch(setInnerPagesList(page));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    },
    onContactClick: (quoter) => {
      dispatch(setStepInnerPage('sendEmail'));
      dispatch(client.sendQuoteByEmail(quoter));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HogarForm_5);